import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import Select from '~/components/Form/Select';
import { toast } from 'react-toastify';
import { MdAdd } from 'react-icons/md';
import api from '~/services/api';
import history from '~/services/history';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Table from '~/components/Table';
import Load from '~/components/Load';

import { Container, Menus, NewButton } from './styles';

export default function IncorporadoraEdit({ match }) {
  const inputRef = useRef(null);
  const [dado, setDado] = useState('');
  const [produtoUnico, setProdutoUnico] = useState(false);
  const [dadosCancelamentos, setDadosCancelamentos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [carregar, setCarregar] = useState(false);
  const [idInc, setIdInc] = useState(0);

  const options = [
    {
      label: 'Não',
      value: false
    },
    {
      label: 'Sim',
      value: true
    }
  ]

  useEffect(() => {
    async function getDados() {
      setLoading(true);
      const { id } = match.params;
      const response = await api.get(`/incorporadora/${id}`);
      setDado(response.data);
      setProdutoUnico(response.data.unique_product)

      setIdInc(id);
    }
    getDados();
  }, [match.params]);

  const getCancelamentos = useCallback(async () => {
    setLoading(true);
    const { id } = match.params;
    const response = await api.get(`/incorporadora/${id}/cancelamento`);
    const data = response.data.map(cancelamento => ({
      ...cancelamento,
      statusFormat: cancelamento.status === '1' ? 'Ativo' : 'Inativo',
    }));
    setDadosCancelamentos(data);
    setLoading(false);
  }, [match.params]);

  useEffect(() => {
    getCancelamentos();
  }, [getCancelamentos, match.params]);

  /**
   * Funções
   */

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
        unique_product: Yup.string().required('Selecione uma opção')
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`/incorporadora/${idInc}`, {
        name: data.name,
        unique_product: produtoUnico
      });

      toast.success('Incorporadora editada com sucesso');
      history.push('/incorporadora');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Incorporadora já foi cadastrada.');
      }
    } finally {
      setCarregar(false);
    }
  }

  function handlerEditar(number) {
    history.push(`/cancelamento/${idInc}/edit/${number}`);
  }

  async function handlerDelete(number) {
    try {
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(
            `/incorporadora/${idInc}/cancelamento/${num}`
          );
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success('Motivo excluído com sucesso');
            getCancelamentos();
          }
        });
      } else {
        const response = await api.delete(
          `/incorporadora/${idInc}/cancelamento/${number}`
        );

        if (response.data) {
          toast.success('Motivo excluído com sucesso');
          getCancelamentos();
        }
      }
    } catch (error) {
      toast.error('Falha ao exlcuir motivo');
    }
  }

  function handleNew() {
    history.push(`/cancelamento/${idInc}/create`);
  }

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'statusFormat',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  if (loading) {
    return <Load />;
  }

  return (
    <>
      <Container>
        <h4>Cadastrar Incorporadora</h4>
        <Card>
          <Form
            ref={inputRef}
            onSubmit={handlerSubmit}
            autoComplete="off"
            initialData={dado}
          >
            <Input icon="MdBusiness" label="Nome" name="name" type="text"  />
            <Select
              name="unique_product"
              labelSelect="Produto único ?"
              options={options}
              onChange={(e) => setProdutoUnico(e.value)}
            />
            <Button tamanho="40px" load={carregar}>
              Editar
            </Button>
          </Form>
        </Card>
        <h4>Listagem de motivos de cancelamento</h4>
        <Card>
          <Menus>
            <NewButton onClick={handleNew}>
              <MdAdd size={16} color="#FFF" />
              Novo
            </NewButton>
          </Menus>
          <Table
            title="Integrações"
            data={dadosCancelamentos}
            columns={columns}
            ds={handlerDelete}
            ed={handlerEditar}
            messages="Você deseja ativar/desativar o motivo?"
            st
          />
        </Card>
      </Container>
    </>
  );
}

IncorporadoraEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
};
